// Google Analytics n'est chargé qu'après consentement explicite de l'utilisateur.

export const GA_MEASUREMENT_ID = 'G-9PHKN828H1';
const DISABLE_FLAG = `ga-disable-${GA_MEASUREMENT_ID}`;

let loaded = false;

export const loadAnalytics = () => {
  window[DISABLE_FLAG] = false;
  if (loaded) return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const disableAnalytics = () => {
  // Flag officiel de Google pour désactiver la collecte si le script est déjà chargé
  window[DISABLE_FLAG] = true;
  deleteGoogleCookies();
};

const deleteGoogleCookies = () => {
  const hostParts = window.location.hostname.split('.');
  const domains = [''];
  for (let i = 0; i < hostParts.length - 1; i++) {
    domains.push(hostParts.slice(i).join('.'));
  }
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (name === '_ga' || name.startsWith('_ga_') || name === '_gid') {
      domains.forEach((domain) => {
        const domainPart = domain ? `; domain=${domain}` : '';
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`;
      });
    }
  });
};
